import type { FC } from 'react';

interface JsonLdProps {
  data: Record<string, unknown>;
}

export const JsonLd: FC<JsonLdProps> = ({ data }) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
  />
);

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '黑料在线',
  url: 'http://baiducc.cn/',
  description: '黑料在线 — 网红八卦资讯聚合平台，提供最新黑料在线观看、播放入口，涵盖黑料吃瓜视频、网红黑料每日实时更新，一站追踪热门爆料。',
  email: 'hello@baiducc.cn',
  telephone: '+86-400-888-8888',
  address: {
    '@type': 'PostalAddress',
    addressLocality: '北京',
    addressCountry: 'CN',
  },
  sameAs: ['http://baiducc.cn/'],
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '黑料在线',
  url: 'http://baiducc.cn/',
  description: '最新黑料在线观看与黑料在线播放入口，黑料在线吃瓜视频，网红黑料每日实时更新爆料。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'http://baiducc.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};